import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { NotificationService } from '../../../../../shared/services';
import { CompanyService } from '../../../../../shared/services/company-service';
import { SetupStoreReportConfigStore } from '../../../../../store';

const EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

@Component({
    selector: 'store-report-config-add-edit-cmp',
    templateUrl: './add-edit.component.html',
    styleUrls: ['./add-edit.component.scss']
})
export class AddEditComponent implements OnInit, AfterViewInit {
    @ViewChild('addConfigModal', { static: true }) public addConfigModal: ModalDirective;
    @Output() onModalClose = new EventEmitter<any>();
    @Input() mode: string;
    @Input() custId: string;

    storeReportConfigModel: any = {};
    edit: boolean = false;
    errMsg: string = '';
    visible: boolean = true;
    stateObj: any;

    incorrectMailFormat: boolean = false;

    serverErrors: any = {};
    form: FormGroup;

    constructor(
        private setupStoreReportConfigStore: SetupStoreReportConfigStore,
        public companyService: CompanyService,
        private notificationService: NotificationService,
        private fb: FormBuilder
    ) {
        this.stateObj = {
            modalVisibility: false,
            refreshGrid: false
        };
    }

    ngAfterViewInit() {
        this.addConfigModal.show();
    }

    onHideModal(event: any) {
        this.stateObj.modalVisibility = false;
        this.onModalClose.emit(this.stateObj);
    }

    ngOnInit() {
        this.initValidation();

        if (this.mode === 'edit') {
            this.edit = true;
            this.visible = false;
            this.setupStoreReportConfigStore.get(this.custId).subscribe(
                (response: any) => {
                    this.storeReportConfigModel = response.data;
                    this.setFormValues(response.data);
                },
                (error: any) => {
                    this.errMsg = 'Un-expected Error';
                    this.notificationService.error(this.errMsg, this.custId + ' Not Found!');
                    this.addConfigModal.hide();
                },
                () => {
                    this.visible = true;
                }
            );
        } else if (this.mode === 'auto') {
            // No known record id — check whether a config already exists for the
            // current company and self-determine add vs edit (used by the Store
            // Report page's "Report Settings" button, which has no list to look at).
            this.visible = false;
            this.setupStoreReportConfigStore.getAll({ xCompanyID: this.companyService.getcompanyID() }).subscribe(
                (response: any) => {
                    const existing = response && response.data && response.data.length ? response.data[0] : null;
                    if (existing) {
                        this.edit = true;
                        this.storeReportConfigModel = existing;
                        this.setFormValues(existing);
                    } else {
                        this.edit = false;
                    }
                    this.visible = true;
                },
                () => {
                    this.edit = false;
                    this.visible = true;
                }
            );
        }
    }

    initValidation(): void {
        this.form = this.fb.group({
            xRecipientEmails: [[], Validators.required],
            xEnabled: [true]
        });
    }

    setFormValues(data: any): void {
        this.form.setValue({
            xRecipientEmails: data.xRecipientEmails || [],
            xEnabled: data.xEnabled
        });
    }

    onItemAddedEditedOrRemoved(val: any): void {
        const emails: any[] = this.form.get('xRecipientEmails').value || [];
        let incorrectFormat = false;
        emails.forEach((email: any) => {
            const value = email.value ? email.value : email;
            if (value !== '' && (value.length <= 5 || !EMAIL_REGEXP.test(value))) {
                incorrectFormat = true;
            }
        });
        this.incorrectMailFormat = incorrectFormat;
    }

    onItemEdited(val: any): void {
        const value = val && val.value ? val.value : val;
        this.incorrectMailFormat = value !== '' && (value.length <= 5 || !EMAIL_REGEXP.test(value));
    }

    onSubmit(modal: any): void {
        if (!this.form.valid || this.incorrectMailFormat) {
            return;
        }
        const formValue = this.form.getRawValue();
        const recipientEmails: string[] = (formValue.xRecipientEmails || []).map((email: any) => email && email.value ? email.value : email);
        const newStoreReportConfig: any = {
            xCompanyID: this.companyService.getcompanyID(),
            xRecipientEmails: recipientEmails,
            xEnabled: formValue.xEnabled
        };

        if (this.edit) {
            this.setupStoreReportConfigStore.update(this.storeReportConfigModel._id, newStoreReportConfig).subscribe(
                () => {
                    this.handleSuccessResponse(modal);
                },
                (error: any) => {
                    this.handleErrorResponse(error);
                }
            );
        } else {
            this.setupStoreReportConfigStore.store(newStoreReportConfig).subscribe(
                () => {
                    this.handleSuccessResponse(modal);
                },
                (error: any) => {
                    this.handleErrorResponse(error);
                }
            );
        }
    }

    handleSuccessResponse(modal: any): void {
        this.notificationService.success('Record Updated.', 'Success!');
        this.stateObj.refreshGrid = true;
        modal.hide();
    }

    handleErrorResponse(errors: any): void {
        this.serverErrors = errors && errors.errors ? errors.errors : {};
        this.notificationService.error(
            errors && errors.message ? errors.message : 'Something went wrong.',
            errors && errors.name ? errors.name : 'Error'
        );
    }

    abortAddConfig(addConfigModal: any): void {
        this.stateObj.refreshGrid = false;
        addConfigModal.hide();
    }
}
